import React from 'react';

const UnauthorizedPage = () => <p>Unauthorized</p>;
export default UnauthorizedPage;
